import { render, staticRenderFns } from "./PrepareDocumentDialog.vue?vue&type=template&id=7f8dab94&scoped=true&"
import script from "./PrepareDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./PrepareDocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrepareDocumentDialog.vue?vue&type=style&index=0&id=7f8dab94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8dab94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VDialog,VSpacer})
